<p-card>
  <p-header class="title"> {{TITLETEXT}}</p-header>
  {{TEXT}}
  <nova-iphone-push></nova-iphone-push>
</p-card>